const barColors = [
  "#284894",
  "#E49A46",
  "#E8E8E8"
];
const bars = document.querySelectorAll(".c-card-houses__bar-inner");


for (var i = 0; i < bars.length; i++) {

  const target = bars[i];
  const bar = target.querySelector(".c-card-houses__bar");
  const labels = target.querySelector(".c-card-houses__bar-labels");
  const inputs = target.querySelectorAll("input[type='hidden']");
  const barData = getBarData(inputs);
  setBars(barData, bar, labels);
}

function getBarData(inputs) {
  const data = [];
  for (var i = 0; i < inputs.length; i++) {
    const item = inputs[i];
    const { name, value } = item;
    data.push({name, value});
  }
  return data;
}

function setBars(data, bar, labels) {
  for (var i = 0; i < data.length; i++) {
    const {name, value} = data[i];
    const line = document.createElement("span");
    line.style.width = `${parseInt(value)}%`;
    const label = document.createElement("li");
    label.classList.add("c-card-houses__bar-label");
    label.innerHTML = name;
    labels.appendChild(label);
    bar.appendChild(line);
  }
}
